import styled from 'styled-components';

import { StyledContainer } from '../../shared/styled-components/styled-container.style';

export const StyledListContainer = styled(StyledContainer)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: auto;
  padding: 0.5rem 0;
`;

